import cx from 'classnames';

import { MIXPANEL_SESSION_REPLAY_CLASS } from 'helpers/mixpanel-init';

import AccountValueCollapsableCard from './AccountValueCollapsableCard';
import AvailableForTrading from './AvailableForTrading';
import ConversionRate from './ConversionRate';
import DeltaCash from './DeltaCash';
import styles from './indianWallet.module.scss';
import { ReferralCommission } from './ReferralCommission';
import SmartAssetEquity from './smartAssetEquity';

const MenuBottom = ({ showAmount }: { showAmount: boolean }) => {
  return (
    (<div
      className={cx(
        styles['wallet-menu'],
        styles.walletMenuBottomContainer,
        MIXPANEL_SESSION_REPLAY_CLASS
      )}
      data-palette="MenuBottom">
      {/* Account Value */}
      <AccountValueCollapsableCard showAmount={showAmount} />
      {/* Available for trading */}
      <AvailableForTrading showAmount={showAmount} />
      {/* Smart Asset */}
      <SmartAssetEquity showAmount={showAmount} />
      {/* Referral Commission */}
      <ReferralCommission showAmount={showAmount} />
      {/* Delta Cash */}
      <DeltaCash showAmount={showAmount} />
      {/* Conversion Rate */}
      <ConversionRate />
    </div>)
  );
};

export default MenuBottom;
